import { useEffect } from 'react';
import { useAuthStore } from '../stores/auth.store';
import { userService } from '../services/api/user.service';

export function useSyncUserTimezone(isAuthenticated: boolean) {
  const { profile, isLoadingProfile, fetchProfile } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated && profile && !isLoadingProfile) {
      const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const userStoredTimeZone = profile.settings?.timeZone?.name;

      if (browserTimeZone && userStoredTimeZone !== browserTimeZone) {
        userService
          .updateUserTimeZone({ timeZoneName: browserTimeZone })
          .then(() => {
            // Refresh the profile in the store after updating timezone
            fetchProfile();
          })
          .catch((err) => {
            console.error('Error updating user timezone on backend:', err);
          });
      }
    }
  }, [isAuthenticated, profile, isLoadingProfile]); // Removed fetchProfile to prevent infinite loop
}
